import React, { Component } from "react";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import LinearProgress from "@mui/material/LinearProgress";
import API from '../../utils/api';

import {
  getCurrentOrg,
  getAllClasses,
  api2Class, api2ClassesByOrganizationId
} from "../../utils/operations.js";
import { observer, inject } from "mobx-react";
import { getAllChildren } from "../../utils/operations";
import { toast } from 'react-toastify';

class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        organisation_id: "",
        name: ""
      },
      organisations: [], // Список организаций
      opendialog: false, // Диалог с ошибками
      openerrordialog: false,
      texterrors: "", // Список ошибок
      showProgress: true,
      changeClass: null,
      gotClasses: null
    };
  }

  handleOpen = () => {
    this.setState({ opendialog: true });
  };

  handleClose = () => {
    this.setState({ showProgress: false });
    this.setState({ opendialog: false });
  };

  // Записать State в state.data.st
  handleStateChange = (event) => {
    const data = this.state.data;
    data.st = event.target.value;
    this.setState({ data });
  };

  componentDidMount() {
    if (!this.props.Auth.can('classes_edit')) { this.props.history.push("/children"); return; }
    this.loadData();
  }

  loadData = () => {
    const itemId = this.props.match.params.id;
    let orgId = this.props.Auth.orgId;

    let that = this;
    axios
      .all([
        API.get(getAllClasses + itemId),
        API.get(getCurrentOrg),
        API.get(api2ClassesByOrganizationId(orgId))
      ])
      .then(
        axios.spread(function(classes, organisations, allclasses) {
          const data = classes.data;
          const organisationsList = organisations.data.resource;
          const allClasses = allclasses.data.data;

          let currentClass = itemId;
          let gotClasses = [];
          for (let i = 0; i < allClasses.length; i++) {
            if (allClasses[i].id != currentClass) {
              gotClasses.push(allClasses[i]);
            }
          }

          that.setState({ gotClasses });
          that.setState({ data: data, organisations: organisationsList });
          that.setState({ showProgress: false });
          if (gotClasses.length > 0) {
            that.setState({ changeClass: gotClasses[0].id });
          }
          that.forceUpdate();
        })
      );
  };

  deleteData = () => {
    this.setState({ opendialog: false });

    const base_url = api2Class(this.state.data.id);
    API.delete(base_url).then(() => {
      toast.success('Class deleted successfully!')
      this.props.history.push("/classes");
    }).catch((error) => {
      let errorMessage = error.response.data.error;

      let table = "Information table";

      if (errorMessage.includes('bills')) {
        table = "Invoices";
      }  else if (errorMessage.includes('teachers')) {
        table = "Teachers";
      }  else if (errorMessage.includes('childs')) {
        table = "Children";
      }  else if (errorMessage.includes('archive')) {
        table = "Archive";
      }

      let textError = "You can't delete class '" + this.state.data.name + "' ";
      textError += "while '" + table + "' corresponding rows exist";

      toast.error(textError, {autoClose: 5000})
    });
  };

  saveData = () => {
    this.setState({ showProgress: true });

    let data = {
      name: this.state.data.name,
      // organisation_id: this.state.data.organisation_id
    };

    const base_url = getAllClasses + this.state.data.id;
    API.patch(base_url, data).then(() => {
      toast.success('Class edited successfully!')
      this.props.history.push("/classes");
    }).catch(function() {
      toast.error('Something wrong!')
    });
  };

  handleOrgChange = (event) => {
    const data = this.state.data;
    data.organisation_id = event.target.value;
    this.setState({ data });
  };

  handleChange = event => {
    const data = this.state.data;
    data[event.target.id] = event.target.value;
    this.setState({ data });
  };

  goPreviousPage = () => {
    this.props.history.goBack();
  };

  transferClass = () => {
    let that = this;
    let classId = this.props.match.params.id;
    let filter = `?filter=(organisation_id%3D${
      this.props.Auth.orgId
    })AND(classes_id%3D${classId})`;

    API.get(getAllChildren + filter).then(res => {
      let children = res.data.resource;
      let newdata = [];
      for (let i = 0; i < children.length; i++) {
        newdata.push({
          id: children[i].id,
          classes_id: this.state.changeClass
        });
      }

        API.put(getAllChildren, { resource: newdata }).then(() => {
          setTimeout(that.props.history.push("/classes"), 1000);
        });
      });
  };

  render() {
    return (
      <div style={{ width: 500, margin: "auto" }}>
        {this.state.gotClasses && this.state.changeClass ? (
          <div>
            <p>Transfer class to:</p>
            <div style={{ display: "flex", flex: 1, flexDirection: "row", alignItems: "center", gap: 10, marginBottom: 16 }}>
              <Select
                value={this.state.changeClass ?? ''}
                onChange={(e) => this.setState({ changeClass: e.target.value })}
                sx={{ minWidth: 160 }}
              >
                {this.state.gotClasses.map(row => (
                  <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>
              <Button variant="text" color="primary" onClick={this.transferClass}>Transfer</Button>
            </div>
          </div>
        ) : null}

        {this.state.showProgress && <LinearProgress />}

        <TextField
          id="name"
          label="Class Name"
          fullWidth
          value={this.state.data.name}
          onChange={this.handleChange}
          sx={{ mb: 2 }}
        />
        <FormControl fullWidth disabled sx={{ mb: 2 }}>
          <InputLabel id="org-label">School</InputLabel>
          <Select
            labelId="org-label"
            label="School"
            value={this.state.data.organisation_id}
            onChange={this.handleOrgChange}
          >
            {this.state.organisations.map(row => (
              <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button variant="contained" color="primary" onClick={this.saveData}>Save</Button>
          <Button variant="contained" sx={{ backgroundColor: "#ffd699", color: "#000", "&:hover": { backgroundColor: "#ffcc77" } }} onClick={this.goPreviousPage}>Cancel</Button>
          {this.props.Auth.can('classes_delete') && (
            <Button variant="contained" color="error" onClick={this.handleOpen}>Delete</Button>
          )}
        </div>

        <Dialog open={this.state.opendialog} onClose={this.handleClose}>
          <DialogContent>Are you sure you want to delete the class? This action cannot be undone.</DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Cancel</Button>
            <Button onClick={this.deleteData} color="primary">OK</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.openerrordialog} onClose={this.handleClose}>
          <DialogContent>{this.state.texterrors}</DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Ok</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default inject("Auth")(observer(EditUser))
